import { Box, Container, Typography, Paper, List, ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Legal = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 4, mb: 6, mt: 12 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          background: 'var(--stat-progress2)',
          borderRadius: '15px',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
          {t('legal.title')}
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('legal.disclaimer.title')}
          </Typography>
          <Typography paragraph>
            {t('legal.disclaimer.content')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('legal.termsOfService.title')}
          </Typography>
          <Typography paragraph>
            {t('legal.termsOfService.content')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('legal.privacyPolicy.title')}
          </Typography>
          <Typography paragraph>
            {t('legal.privacyPolicy.content')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('legal.dataProtection.title')}
          </Typography>
          <Typography paragraph>
            {t('legal.dataProtection.content')}
          </Typography>
          <List dense>
            {(t('legal.dataProtection.rights', { returnObjects: true }) as string[]).map((item, index) => (
              <ListItem key={index}>
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('legal.cookies.title')}
          </Typography>
          <Typography paragraph>
            {t('legal.cookies.content')}
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {t('legal.contact.title')}
          </Typography>
          <Typography paragraph>
            {t('legal.contact.content')}
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
          {t('legal.lastUpdate')}
        </Typography>
      </Paper>
    </Container>
  );
};

export default Legal;
